module.exports = __webpack_public_path__ + "img/logo.13e221af.png";